import React from 'react'
import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'
import useDarkMode from 'use-dark-mode'
import * as qs from 'qs'
import { useFetchPage } from 'hooks'
import { useLocale } from 'hooks'

const { REACT_APP_STRAPI_API_URL } = process.env

const MakesBetter = ({ ...props }) => {
  const darkMode = useDarkMode()
  const isDark = darkMode.value
  const { locale } = useLocale()

  const query = qs.stringify({
    locale: [locale],
    populate: {
      items: {
        populate: {
          icon: {
            fields: ['url']
          },
          DarkModeIcon: {
            fields: ['url']
          }
        }
      }
    }
  })

  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/Avax-makesbetter?${query}`).then(
      res => res.json()
    )
  const { data } = useFetchPage(['/api/makesbetter', locale], fetcher)
  return (
    <Container {...props}>
      <H3 isDark={isDark}>{data?.title}</H3>
      <GridLayout>
        {data?.items?.map(element => (
          <Flex key={element?.title}>
            <img
              src={
                isDark
                  ? REACT_APP_STRAPI_API_URL +
                    element?.DarkModeIcon?.data?.attributes?.url
                  : REACT_APP_STRAPI_API_URL +
                    element?.icon?.data?.attributes?.url
              }
              alt="Image"
            />
            <HTitle isDark={isDark} style={{ margin: '21px 0' }}>
              {element?.title}
            </HTitle>
            <PContent isDark={isDark}>{element?.description}</PContent>
          </Flex>
        ))}
      </GridLayout>
    </Container>
  )
}

export default MakesBetter

const Container = styled('div')`
  margin-top: 250px;
`

const H3 = styled('div')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 116.7%;
  color: ${({ isDark }) => (isDark ? '#fff' : 'rgba(0, 0, 0, 0.87)')};
  text-align: center;

  ${mq.medium`
    font-size: 48px;
  `};
`

const GridLayout = styled('div')`
  display: grid;
  align-items: center;
  justify-items: center;
  row-gap: 40px;
  margin-top: 60px;

  img {
    height: 70.5px;
    width: 76.5px;
  }

  ${mq.medium`
    grid-template-columns: repeat(2, 1fr);
    grid-template-row: repeat(2, 1fr);
    column-gap: 35px;
    row-gap: 35px;
  `};

  ${mq.large`
    grid-template-columns: repeat(4, 1fr);
  `};

  .better-element {
    ${mq.medium`
      height: 100%;
    `};
  }
`

const HTitle = styled('div')`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 26.251px;
  line-height: 103%;
  color: ${({ isDark }) => (isDark ? '#fff' : '#000')};
  text-align: center;
`

const PContent = styled('div')`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12.0005px;
  line-height: 172%;
  text-align: center;
  letter-spacing: 0.065em;
  color: ${({ isDark }) => (isDark ? '#fff' : '#000')};
`

const Flex = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
